import { Dispatch, SetStateAction } from 'react'
import { useNavigate } from 'react-router'
import { Button, DialogContent, DialogContentText, Grid } from '@mui/material'
import { useSnackbar } from 'notistack'

import DialogWithTitle from '../../../../components/dialog-with-title'
import Api from '../../../../utils/api'
import useStyles from '../discard-modal/index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  releaseNoteId: number
}

const DeleteModal = (props: IProps) => {
  const { open, setOpen, releaseNoteId } = props

  const classes = useStyles
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const handleDelete = async () => {
    const res = await Api.del(`/api/v2/releases/${releaseNoteId}`)

    if (res.ok) {
      enqueueSnackbar('The release note was successfully deleted')
      navigate('/release-notes')
    } else {
      enqueueSnackbar('Can not delete this release note. Please try again later', { variant: 'error' })
      setOpen(false)
    }
  }

  return (
    <DialogWithTitle title="Delete" open={open} setOpen={setOpen}>
      <DialogContent>
        <DialogContentText sx={classes.text}>Are you sure you want to delete this release note?</DialogContentText>

        <DialogContentText sx={classes.text}>Cannot undo this action</DialogContentText>

        <Grid
          container={true}
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <Button variant="outlined" sx={classes.dialogButtons} onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <Button variant="contained" sx={classes.dialogButtons} onClick={handleDelete} color="error">
            Delete
          </Button>
        </Grid>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default DeleteModal
